import { atom } from 'recoil';
import { HttpEvent } from 'utils/HttpEvent';

export const notificationsAtom = atom<HttpEvent[]>({
  key: 'notifications',
  default: [],
});
